import { Box, Button, IconButton, Paper, Typography, Chip } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TodayIcon from "@mui/icons-material/Today";
import { formatRangoSemana } from "../../common/utils/semana";

const SemanaNavigator = ({ desde, hasta, esSemanaActual, onPrev, onNext, onHoy }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        p: 1.5,
        px: 2,
        borderRadius: 4,
        border: "1px solid rgba(0,0,0,0.08)",
        background: "linear-gradient(135deg, #eef5fb 0%, #f7fbff 100%)",
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton onClick={onPrev} size="small" sx={{ bgcolor: "white", boxShadow: 1 }}>
          <ChevronLeftIcon />
        </IconButton>
        <Box sx={{ minWidth: 190, textAlign: "center" }}>
          <Typography sx={{ fontWeight: 700, fontSize: "1.05rem", color: "#1F618D" }}>
            {formatRangoSemana(desde, hasta)}
          </Typography>
        </Box>
        <IconButton onClick={onNext} size="small" sx={{ bgcolor: "white", boxShadow: 1 }}>
          <ChevronRightIcon />
        </IconButton>
      </Box>

      {esSemanaActual ? (
        <Chip
          icon={<TodayIcon sx={{ fontSize: 16 }} />}
          label="Semana actual"
          color="primary"
          size="small"
          sx={{ fontWeight: 600 }}
        />
      ) : (
        <Button
          size="small"
          startIcon={<TodayIcon />}
          onClick={onHoy}
          sx={{ borderRadius: 3, textTransform: "none", fontWeight: 600 }}
        >
          Ir a la semana actual
        </Button>
      )}
    </Paper>
  );
};

export default SemanaNavigator;
